<template lang="pug">
  div.user
    div.content(v-if="loading==='loaded' && switching==='switched'")
      img(:src="head", class='user_head')
      p(class='user_uid') UID:{{userInfo.userInfo.cpUid}}
      p(v-if="userStatus !== 1 && loadingUB==='loadedUB' && showInte === 'true'", class='user_integral') {{$t('integral')}}:{{uBalance.integral}}
      van-cell-group.user_list_box(v-if="userStatus === 0 && userInfo.userInfo.getReward === '0' && showInte === 'true'")
        van-cell(class="uindex_btn", :title="$t('getReward')", @click="getReward")
      van-cell-group.user_list_box(v-if="loginTypes.includes('inherit')")
        van-cell(v-if="userInfo.userInfo.inheritStatus == 1", :title="$t('inheritId')", is-link, to='/user/inherit')
          template(#icon)
            img(src='@/assets/inherit_id.png', class="user_list_icon")
        van-cell(v-else, :title="$t('inheritId')", is-link, to='/user/inheritComp')
          template(#icon)
            img(src='@/assets/inherit_id.png', class="user_list_icon")
      van-cell-group.user_list_box(v-if="!loginTypes || loginTypes.includes('platAccount')")
        van-cell(v-if="userStatus === 0", :title="$t('changePassword')", is-link, to='/user/changePwd')
          template(#icon)
            img(src='@/assets/change_pwd.png', class="user_list_icon")
        van-cell(v-if="userStatus === 2", :title="$t('updateId')", is-link, to='/user/updateUid')
          template(#icon)
            img(src='@/assets/update_uid.png', class="user_list_icon")
        van-cell(v-if="userStatus === 1", :title="$t('bindId')", is-link, to='/user/bindUid')
          template(#icon)
            img(src='@/assets/update_uid.png', class="user_list_icon")
        van-cell(:title="$t('bindEmail')", is-link, @click="emailHandle")
          template(#icon)
            img(src='@/assets/bind_email.png', class="user_list_icon")
      van-cell-group.user_list_box
        van-cell(:title="$t('recordOfconsume')", is-link, to='/user/consume')
          template(#icon)
            img(src='@/assets/cost_record.png', class="user_list_icon")
        //- van-cell(title="NT充值记录", is-link, to='/user/ntRecord')
        //-   template(#icon)
        //-     img(src='@/assets/ntpoint_record.png', class="user_list_icon")
      van-cell-group.user_list_box(v-if="showInte === 'true'")
        van-cell(v-if="userStatus !== 1", :title="$t('giftBagPurchase')", is-link, to='/user/pointBuy')
          template(#icon)
            img(src='@/assets/point_cost.png', class="user_list_icon")
        van-cell(v-if="userStatus !== 1", :title="$t('integralIncome')", is-link, to='/user/pointCost')
          template(#icon)
            img(src='@/assets/point_buy.png', class="user_list_icon")
      van-cell-group.user_list_box(v-if="showInte === 'true'")
        van-cell(:title="$t('exchange')", is-link, to='/user/exchange')
          template(#icon)
            img(src='@/assets/exchange.png', class="user_list_icon")
      van-cell-group.user_list_box(v-if="showGameRule === 'true'")
        van-cell(:title="$t('gameRegulations')", is-link, to='/user/gameRegulations')
          template(#icon)
            img(src='@/assets/game_regulations.png', class="user_list_icon")
      van-cell-group.user_list_box(v-if="showPrivacy === 'true'")
        van-cell(:title="$t('privacy')", is-link, @click="privacyHandle")
          template(#icon)
            img(src='@/assets/game_regulations.png', class="user_list_icon")
      van-cell-group.user_list_box(v-if="showLogCode === 'true'")
        //- van-cell-group.user_list_box
        van-cell(:title="$t('getLogCode')", is-link, @click="logCodePop")
          template(#icon)
            img(src='@/assets/getLogCode.png', class="user_list_icon")
      van-cell-group.user_list_box(v-if="!loginTypes || loginTypes != 'guest'")
        //- van-cell-group.user_list_box
        van-cell(:title="$t('logout')", is-link, @click="closePage")
          template(#icon)
            img(src='@/assets/logout.png', class="user_list_icon")
    van-dialog(v-model="logCodeShow", :title="$t('logCode')", v-if="logCode.loginCode"  :show-confirm-button='false', :show-cancel-button='false', :close-on-click-overlay="true")
      div(style="display:flex; justify-content: space-around; margin: 0 60px;")
        p(class="log_code" v-for="item in logCode.loginCode.split('')") {{item}}
      van-button(type="danger", size="mini", class="copy_btn copy", @click="copyHandle()") {{$t('copy')}}
      p(style="font-size:14px; text-align:center; color: #b3b3b3;") {{$t('10minLimit')}}
    //- router-view
</template>

<script>
import Clipboard from 'clipboard'
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast } from 'vant';

export default {
  name: 'User',
  data(){
    return{
      head: require('@/assets/head_icon.png'),
      logCodeShow: false,
      uploader:[],
      updata: [],
      userStatus: 0,
      showInte: 'false',
      showGameRule: 'true',
      showPrivacy: 'true',
      isDisabled: true,
      showLogCode: "false",
    }
  },
  created(){
    const accountType = this.userInfo.userInfo && this.userInfo.userInfo.accountType
    if(accountType === '2' || accountType === '12'){
      this.userStatus = 0
    } else if(accountType === '1'){
      this.userStatus = 1
    } else {
      this.userStatus = 2
    }
  },
  methods:{
    ...mapActions(['getSwitchInfo', 'getUserInfo']),
    ...mapActions('record', ['getUserBalance']),
    ...mapActions('user', ['integralAward', 'getLogCode', 'checkWhitelist']),
    privacyHandle(){
      // window.location.href = 'https://qa.newtypegames.com/privacy?lang=en'
      if(this.lang == 'zh-CN'){
        window.location.href = 'https://www.newtypegames.com/privacy?lang=zh'
      } else if(this.lang == 'zh-TW' || this.lang == 'zh-HK'){
        window.location.href = 'https://www.newtypegames.com/privacy?lang=zh-hmt'
      } 
      else if(this.lang == 'ko-KR' ){
        window.location.href ='https://www.newtypegames.com/privacy?lang=ko'//'https://www.moossangjr.com/privacy/index.html'
      }
       else if(this.lang == 'ru-RU'){
        window.location.href = 'https://www.newtypegames.com/privacy?lang=ru'
      } else {
        window.location.href = 'https://www.newtypegames.com/privacy?lang=en'
      }
    },
    logCodePop(){
      this.logCodeShow = true
      this.getLogCode({
        appId: this.appid,
        areaId: this.areaId,
        roleId: this.roleId,
        serverId: this.serverId,
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        language: this.lang,
        clientPlat: this.clientPlat
      })
    },
    getReward(){
      if(!this.isDisabled){
        return false
      }
      this.isDisabled = false
      this.integralAward(Qs.stringify({
        appId: this.appid,
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token
      }))
    },
    emailHandle(){
      if(this.userInfo.userInfo.bindEmailStatus === 'true'){
        this.$router.push({
          path: "/user/checkEmail",
          query: {
            email: this.userInfo.userInfo.email
          }
        })
      } else {
        this.$router.push({
          path:'/user/bindEmail'
        })
      }
    },
    getCookiesObj() { 
      return document.cookie.split(';').reduce((f, sv) => {
          let _sv = sv.trim().split('=').map(v => {
              return v.trim()
          })
          f[_sv[0]] = _sv[1]
          return f
      }, {})
    },
    closePage(){
      typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.doPlatLogout({}) || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.doPlatLogout.postMessage(null))
    },
    copyHandle(){
      let data = this.logCode.loginCode
      let clipboard = new Clipboard('.copy', {
        text: function () {
          return data
        }
      })
      clipboard.on('success', e => {
        typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(this.$t('copySuccess')) || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.showToastForJS.postMessage(this.$t('copySuccess')))
        // Toast({
        //     message: this.$t('copy'),
        //     type: "success",
        //     closeOnClick: true
        // })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        Toast({
            message: this.$t('copied'),
            type: "fail",
            closeOnClick: true
        })
        clipboard.destroy()
      })
    }
    // onSubmit(){
    //   let items = this.uploader.values();
    //   console.log(this.uploader);
    //   for(let item of items){
    //     this.updata.push(this.dataURLtoFileFun(item.content, item.file.name, item.file.type));
    //   }
    //   console.log(this.updata);
    // },

    // dataURLtoFileFun (dataurl, filename, type) {
    //   let arr = dataurl.split(",");
    //   let mime = arr[0].match(/:(.*?);/)[1];
    //   let bstr = atob(arr[1]);
    //   let n = bstr.length;
    //   let u8arr = new Uint8Array(n);
    //   while (n--) {
    //     u8arr[n] = bstr.charCodeAt(n);
    //   }
    //   return new File([u8arr], filename, { type: type });
    // }
  },
  computed:{
    ...mapGetters(['cpUid', 'uid', 'deviceId', 'channelId', 'token', 'appid', 'loading', 'userInfo', 'switching', 'switchInfo', 'loginTypes', 'areaId', 'roleId', 'serverId', 'lang', 'clientPlat']),
    ...mapGetters('record', ['uBalance', 'loadingUB']),
    ...mapGetters('user', ['awReturn', 'awStatus', 'logCode', 'lcLoading', 'whiteList', 'wlLoading'])
  },
  mounted(){
    // if(this.token){
    //   this.getUserInfo(Qs.stringify({
    //     appId: this.appid,
    //     uid: this.uid,
    //     deviceId: this.deviceId,
    //     accessToken: this.token
    //   }));
    // }
    this.$watch('wlLoading', val => {
      if(val === 'loaded'){
        if(this.whiteList.checkResult){
          this.showLogCode = 'true'
        }
      }
    })
    this.$watch('awStatus', val => {
      this.isDisabled = true
      if(val === "stated"){
        Toast({
          message: this.$t('getOk'),
          type: 'success',
          onClose: () => {
            this.getUserBalance({
                appId: this.appid,
                uid: this.uid,
                deviceId: this.deviceId,
                accessToken: this.token
            })
            this.getUserInfo(Qs.stringify({
              appId: this.appid,
              uid: this.uid,
              deviceId: this.deviceId,
              accessToken: this.token
            }));
          }
        })
      }
    })
    this.$watch('loading', val => {
      if(val === 'loaded'){
        const accountType = this.userInfo.userInfo.accountType
        if(accountType === '2' || accountType === '12'){
          this.userStatus = 0
        } else if(accountType === '1'){
          this.userStatus = 1
        } else {
          this.userStatus = 2
        }
      }
    })
    if(this.token && this.appid){
        // const accountType = this.userInfo.userInfo.accountType
        // if(accountType === '2' || accountType === '12'){
        //   this.userStatus = 0
        // } else if(accountType === '1'){
        //   this.userStatus = 1
        // } else {
        //   this.userStatus = 2
        // }
        this.getUserBalance({
            appId: this.appid,
            uid: this.uid,
            deviceId: this.deviceId,
            accessToken: this.token
        })
        // if(this.switchInfo.switchInfoList){
        this.getSwitchInfo({
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          appId: this.appid,
          channelId: this.channelId,
          switchId: "11,12,13,22,26,28"
        })
        // }
    }
    this.$watch('appid', val => {
      // window.webkit.messageHandlers.showToastForJS.postMessage(this.deviceId)
      this.$store.commit('INIT', {
        uid: this.getCookiesObj() && this.getCookiesObj()['uid'] || '',
        cpUid: this.getCookiesObj() && this.getCookiesObj()['cpUid'] || '',
        token: this.getCookiesObj() && decodeURIComponent(this.getCookiesObj()['ntToken']) || '',
      })
      if(val){
        this.getUserBalance({
            appId: this.appid,
            uid: this.uid,
            deviceId: this.deviceId,
            accessToken: this.token
        })
      }
    })
    this.$watch('switching', val => {
      if(val === 'switched'){
        if(this.switchInfo.switchInfoList[11]){
          this.showInte = this.switchInfo.switchInfoList[11]
        }
        if(this.switchInfo.switchInfoList[22]){
          this.showGameRule = this.switchInfo.switchInfoList[22]
        }
        if(this.switchInfo.switchInfoList[28]){
          this.showPrivacy = this.switchInfo.switchInfoList[28]
        }
        if(this.switchInfo.switchInfoList && this.switchInfo.switchInfoList[26]){
          if(this.switchInfo.switchInfoList[26] === 'true'){
            this.showLogCode = 'true'
          }
        }
        this.checkWhitelist({
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          appId: this.appid,
          channelId: this.channelId
        })
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.user{
  background: url("../../assets/userbg.png") 0 0 no-repeat;
  width: 100%;
  background-size: 100% auto !important;
  margin-top: -21px;
  .copy_btn{
    float: right;
    margin-top: -50px;
    margin-right: 20px;
    font-size: 10px;
    // color: #e00b16;
  }
  .van-dialog__header{
    margin-top: 10px;
  }
  .van-dialog__content{
    .log_code{
      margin: 20px 0px;
      text-align: center;
      font-size: 30px;
      color: #e00b16;
      text-decoration: underline;
      text-decoration-color: #e6e6e6;
    }
  }
  .content{
    margin: 10px;
    .user_head{
      width: 20%;
      position: relative;
      left: 50%;
      margin-left: -10%;
      padding-top: 10px;
    }
    .user_uid{
      text-align: center;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      margin: 0;
    }
    .user_integral{
      text-align: center;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      margin: 0;
    }
    .user_list_box{
      margin: 0 10px;
      margin-top: 10px;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 0px 0px 5px 2px #ebebeb;
      .van-cell{
        border-radius: 0;
      }
    }
    .user_list_icon{
      width: 14px;
      height: 16px;
      position: relative;
      padding: 3px 10px 3px 0;
    }
    .uindex_btn{
      text-align: center;
    }
  }
}
</style>